module.exports = __webpack_public_path__ + "static/media/AnovaUI-Regular.3c306379.woff2";